import React from 'react'    

const getDesc=(val)=>{
  return(
    (val && val.toUpperCase()==='Y')? 'Yes' : (val && val.toUpperCase()==='N')? 'No':  (val && val.toUpperCase()==='/')? 'N/A' : ''
  )
}
    
const tableStyle = {
    margin: "auto",  
    width:"100%" ,  
    borderCollapse:"collapse",
    padding: "0",
    textAlign: "left",
    fontSize: "9px",
  };

  const tableStyleCenter = {
    margin: "auto",  
    width:"100%" ,  
    borderCollapse:"collapse",
    padding: "0",
    textAlign: "center",
    fontSize: "9px"
  };

const outerTable = {
    margin: "20px 10px 2px 20px",   
    borderCollapse:"collapse",
    padding: "0",
    width: "780px",

  };

const PhlebotoView=({record})=>{
    
    return(
    <div>
        <table border='1' cellPadding="5" cellSpacing="0"  style={tableStyle}>
        <tbody>
        <tr>
            <td>
            <table border='1' cellPadding="5" cellSpacing="0"  style={tableStyleCenter}>
                        <tbody>
                            <tr>
                                <th>Booth#</th>
                                <th>Start Time</th>
                                <th>Weight<br/>110-400 lbs</th>
                                <th>Collected Volume<br/>690, 825, 880 ml</th>
                                <th>Blood Pressure<br/>100-180/50-100 mmHg</th>
                                <th>Pulse<br/>56-100 bpm</th>
                                <th>Temperature<br/>97-99.4 F</th>
                                <th>Hematocrit<br/>Female:38%-54%<br/>Male:39%-54%</th>
                                <th>Total<br/>Protein 6.0-9.0 g/dl</th>
                                <th>Donor<br/>Processor Initials</th>
                            </tr>
                            <tr>
                                <td>{record.booth_num}</td>
                                <td>{record.start_time}</td>
                                <td>{record.weight}</td>
                                <td>{record.volume_collected}</td>
                                <td>{record.blood_pressure}</td>
                                <td>{record.pulse}</td>
                                <td>{record.temperature}</td>
                                <td>{record.hematocrit}</td>
                                <td>{record.total_protein}</td>
                                <td>{record.donor_processor_init}</td>
                            </tr>
                            <tr>
                                <td colSpan="10" style={{textAlign:'left'}} >Screening Comments:&nbsp;&nbsp;&nbsp;{record.comments_screening}</td>
                            </tr>
                            </tbody>
                        </table>
                        <table border='1' cellPadding="5" cellSpacing="0"  style={tableStyleCenter}>
                        <tbody>
                            <tr>
                               
                                <th >Physician Substitute Review from Donors Requiring Physical</th>
                                <td >{record.phy_sub_review}</td>
                                <th >Control Desk Review</th>
                                <td >{record.control_review}</td>
                            </tr>
                            <tr>
                                <th>Control Number</th>
                                <td >{record.control_num}</td>
                                <td colSpan={2}>&nbsp;</td>
                            </tr>
                            </tbody>
                        </table>
                        <table border='1' cellPadding="5" cellSpacing="0"  style={tableStyleCenter}>
                        <tbody>
                            <tr>
                                <th>Quantity used: Plasmacell-C Kit</th>
                                <th>Quantity used: A/C</th>
                                <th>Quantity used: Saline</th>
                                <th>Quantity used: Bottle</th>
                                <th>Quantity used: Needle</th>
                                <th>PCS #</th>
                                <th>Arm used</th>
                                <th>Start time</th>
                                <th>Tech. Initial</th>
                                <th>Sample Collected</th>
                                <th>Disconnect Time</th>
                                <th>Volume Collected</th>
                                <th>D/C Tech. Initial</th>
                            </tr>
                            <tr>
                                <td>{record.ckit}</td>
                                <td>{record.qty_ac}</td>
                                <td>{record.qty_saline}</td>
                                <td>{record.qty_bottle}</td>
                                <td>{record.qty_needle}</td>
                                <td>{record.pcs_num}</td>
                                <td>{record.arm_used}</td>
                                <td>{record.process_start_time}</td>
                                <td>{record.tech_init}</td>
                                <td>{getDesc(record.sample_collected)}</td>
                                <td>{record.disc_time}</td>
                                <td>{record.volume_collected_2}</td>
                                <td>{record.dc_tech_init}</td>
                            </tr>
                            <tr>
                                <td colSpan='13' style={{textAlign:'left'}}>
                                    <b>Donation Comments:</b>&nbsp;&nbsp;&nbsp;{record.comments_donnor}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan='13' style={{textAlign:'left'}}>
                                    <b>Incident:</b>&nbsp;&nbsp;&nbsp;{record.incident}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan='13' style={{textAlign:'left'}}>
                                    <b> Donor drank 20oz Gatorade:</b>&nbsp;&nbsp;&nbsp;{record.donor_gatorade}
                                </td>
                            </tr>
                            </tbody>
                        </table>

            </td>
        </tr>    
        </tbody>
        </table>
    </div>
    )
}

export default PhlebotoView;
